import useMediaQuery from '@material-ui/core/useMediaQuery';

export default useMediaQuery;
